module.exports = {"id":"dp2_6l3q2","text":"Managing Digital Identity","instructions":"Which is an example of passively generated digital identity data?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.6","questionType":"PickOne","random":true,"options":[{"id":"dp2_6l3q2-a1","text":"Location tracking metadata","score":3.7},{"id":"dp2_6l3q2-a2","text":"Profile biography text","score":1.3},{"id":"dp2_6l3q2-a3","text":"Manually posted comments","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.6/l3q2.json
// module id = 1096
// module chunks = 41